import React from 'react';
import { MarketingStatus } from '../../../../domain/FilterTypes';
import { marketingStatusOptions } from '../../../../domain/filterOptions';
import { useFilterController } from '../../../../application/useFilterController';

export const StatusDrawerSection = () => {
  const { marketingStatus, setMarketingStatus } = useFilterController();

  const onChange = (newStatus: MarketingStatus) => {
    setMarketingStatus(newStatus);
  };

  return (
    <div className="p-4 flex justify-center">
      <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden items-center justify-center">
        {marketingStatusOptions.map((option, index) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`px-6 py-2 text-sm font-medium transition-colors ${
              marketingStatus === option.value
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            } ${
              index > 0 ? 'border-l border-gray-300' : ''
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
